import React from 'react';
import { Typography } from '@equinor/opt-ui-core';
import { FlexBlock } from 'Widgets/ui/Layout';
const HeatMapLabel = ({ label, children = null }) => (React.createElement(FlexBlock, { className: "app-chart__heatmap-label" },
    children,
    React.createElement(Typography, { fontSize: "14px", fontWeight: 500, css: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' } }, label)));
export default HeatMapLabel;
